import Button from '@atlaskit/button'
import { colors } from '@atlaskit/theme'
import { css } from '@emotion/react'
import React from 'react'
import analytics from '../services/analytics'

export default function Footer() {
  return (
    <footer className='page-footer'>
      <div>
        <span
          css={css`
            text-align: center;
          `}
        >
          Data exchanged between these integrations and Atlassian products is secured by encryption
          and complies with{' '}
          <Button
            appearance='subtle-link'
            href='https://www.atlassian.com/trust/data-protection'
            rel='noreferrer'
            spacing='none'
            target='_blank'
          >
            our data-protection policies
          </Button>
          .
        </span>
      </div>
      <div>
        <Button
          appearance='subtle-link'
          css={css`
            span {
              color: ${colors.N500};
            }
          `}
          href='https://www.atlassian.com/legal/privacy-policy'
          onClick={() => analytics.events.atlLinkClick('privacyPolicy')}
          rel='noreferrer'
          target='_blank'
        >
          Privacy policy
        </Button>
        <Button
          appearance='subtle-link'
          css={css`
            span {
              color: ${colors.N500};
            }
          `}
          href='https://www.atlassian.com/legal/cloud-terms-of-service'
          onClick={() => analytics.events.atlLinkClick('terms')}
          rel='noreferrer'
          target='_blank'
        >
          Terms
        </Button>
        <span
          css={css`
            margin: 0 12px;
            color: ${colors.N500};
          `}
        >
          Copyright © {new Date().getFullYear()} Atlassian
        </span>
      </div>
    </footer>
  )
}
